(function () {
  if (window.gnwXmasCrosssellLoaded) return;
  window.gnwXmasCrosssellLoaded = true;

  var physicalHandles = [
    'adventskalender-24-stoffbeutel',
    'adventskalender-glas-mit-holzdeckel-personalisiert',
    'adventskalenderglas-mit-holzdeckel-24-tage-bis-weihnachten'
  ];
  var digitalHandles = [
    '24-kleine-momente-fuer-uns-paare',
    '24-kleine-weihnachtsabenteuer-kinder',
    '24-kleine-mutmacher-adventskalender'
  ];

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-gnw-xmas-crosssell]'));
  }

  function setVisibility(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var hasPhysical = cart.items.some(function (item) { return physicalHandles.indexOf(item.handle) !== -1; });
    var hasDigital = cart.items.some(function (item) { return digitalHandles.indexOf(item.handle) !== -1; });
    roots().forEach(function (root) { root.hidden = !(hasPhysical && !hasDigital); });
  }

  function fetchCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) { setVisibility(cart); return cart; })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gnw-xmas-crosssell-add]');
    if (!button) return;
    event.preventDefault();
    var root = button.closest('[data-gnw-xmas-crosssell]');
    var status = root && root.querySelector('[data-gnw-xmas-crosssell-status]');
    button.disabled = true;
    if (status) status.textContent = 'PDF wird hinzugefügt …';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
    })
      .then(function (response) { return response.json().then(function (data) { if (!response.ok) throw data; return data; }); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        if (status) status.textContent = 'PDF wurde hinzugefügt. Der Rabatt wird automatisch berechnet.';
      })
      .catch(function () { if (status) status.textContent = 'Das PDF konnte nicht hinzugefügt werden. Bitte versuche es erneut.'; })
      .finally(function () { button.disabled = false; });
  });

  document.addEventListener('cart:updated', function (event) { if (event.detail && event.detail.cart) setVisibility(event.detail.cart); else fetchCart(); });
  document.addEventListener('ajaxProduct:added', function () { window.setTimeout(fetchCart, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fetchCart); else fetchCart();
})();
